<template>
  <TitleFrame text="ユーザ設定">
    <template slot="contents">
      <div class="mainContent">
        <p class="description">
          利用者の特性に基づいて最適な情報を提供しますので、ユーザ設定をお願いします
        </p>
        <div>
          <p class="label">性別</p>
          <div class="gender-options">
            <p
              @click="onClickGender(genderList[0])"
              class="button"
              :class="{ selected: selected.gender === genderList[0] }"
            >
              <img
                src="@/assets/man.svg"
                v-show="selected.gender !== genderList[0]"
              />
              <img
                src="@/assets/man-white.svg"
                v-show="selected.gender === genderList[0]"
              />
              {{ genderList[0] }}
            </p>
            <p
              @click="onClickGender(genderList[1])"
              class="button"
              :class="{ selected: selected.gender === genderList[1] }"
            >
              <img
                src="@/assets/woman.svg"
                v-show="selected.gender !== genderList[1]"
              />
              <img
                src="@/assets/woman-white.svg"
                v-show="selected.gender === genderList[1]"
              />
              {{ genderList[1] }}
            </p>
            <p
              @click="onClickGender(genderList[2])"
              class="button"
              :class="{ selected: selected.gender === genderList[2] }"
            >
              {{ genderList[2] }}
            </p>
            <p
              @click="onClickGender(genderList[3])"
              class="button"
              :class="{ selected: selected.gender === genderList[3] }"
            >
              {{ genderList[3] }}
            </p>
          </div>
        </div>
        <hr />
        <div>
          <p class="label">年代</p>
          <div class="age-options">
            <p
              v-for="item in ageList"
              :key="item"
              @click="onClickAge(item)"
              class="button"
              :class="{ selected: item === selected.age }"
            >
              {{ item }}
            </p>
          </div>
        </div>
        <hr />
        <SelectBoxArea
          text="居住都道府県"
          :item-list="prefList"
          :initialValue="selected.pref"
          @change-value="changePref"
        />
        <div class="ngWrapper">
          <p class="ng" v-if="!isValidationOk">未設定項目があります</p>
        </div>
        <ButtonTextLink
          text="設定する"
          :disable="!isValidationOk"
          @click-text="onSubmit"
        />
      </div>
    </template>
  </TitleFrame>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { AGE_LIST, PREF_LIST } from "../../const.js";
import TitleFrame from "@/components/Templates/TitleFrame";
import Firebase from "./../../firebase";
import SelectBoxArea from "@/components/Atoms/SelectBoxArea";
import ButtonTextLink from "@/components/Atoms/ButtonTextLink";

export default {
  name: "settings",
  components: {
    TitleFrame,
    SelectBoxArea,
    ButtonTextLink,
  },
  computed: {
    genderList() {
      return ["男性", "女性", "その他", "回答しない"];
    },
    ageList() {
      return AGE_LIST;
    },
    prefList() {
      return PREF_LIST;
    },
    isValidationOk() {
      return (
        this.selected.gender !== "" &&
        this.selected.age !== "" &&
        this.selected.pref !== ""
      );
    },
  },
  data() {
    return {
      selected: {
        gender: "",
        age: "",
        pref: "",
      },
    };
  },
  methods: {
    ...mapMutations(["loadingStartMini", "loadingEndMini"]),
    changePref(e) {
      this.selected.pref = e.ans;
    },
    onClickGender(e) {
      this.selected.gender = e;
    },
    onClickAge(e) {
      this.selected.age = e;
    },
    async onSubmit() {
      this.loadingStartMini();
      await Firebase.putUserSettings(this.selected);
      this.loadingEndMini();
      this.$router.push({ name: "Research" });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../../unified.scss";
.mainContent {
  padding: 1rem;
}
.description {
  margin-bottom: 1rem;
}
.label {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 0.5rem;
  &::before {
    content: "";
    background: #5cd5d6;
    width: 3px;
    height: calc(1rem + 0.1rem);
    margin-right: 0.25rem;
    display: inline-block;
  }
}
hr {
  border: none;
  border-top: 1px #858585 solid;
  margin: 1rem 0;
}

p {
  margin: 0;
}

.gender-options {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 1rem;
}
.age-options {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 1rem;
}

.button {
  display: flex;
  width: 100%;
  text-align: center;
  align-items: center;
  justify-content: center;
  padding: 0.3rem 0;
  border: 1px #e7e7e7 solid;
  border-radius: 4px;
  background: #eeeeee;
  &.selected {
    background: #5cd5d6;
    color: #fff;
  }
  img {
    height: 1.5rem;
    margin-right: 0.5rem;
  }
}
.ng {
  margin-top: 0.25rem;
  color: #ff7c86;
  font-size: 0.75rem;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/Settings.vue